"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAssociateContactPreferences = getAssociateContactPreferences;
exports.getAssociateContactPreferencesByEmail = getAssociateContactPreferencesByEmail;
exports.resetSaveAssociateContactPreferencesByEmail = resetSaveAssociateContactPreferencesByEmail;
exports.saveAssociateContactPreferences = saveAssociateContactPreferences;
exports.saveAssociateContactPreferencesByEmail = saveAssociateContactPreferencesByEmail;
exports.unsubscribeFromAssociateContactPreferenceByEmail = unsubscribeFromAssociateContactPreferenceByEmail;
var _serviceProviderGatewayActionKeys = _interopRequireDefault(require("../constants/serviceProviderGatewayActionKeys"));
var _serviceProviderGatewayService = _interopRequireDefault(require("../services/serviceProviderGatewayService"));
function getAssociateContactPreferences(userId) {
  return {
    type: _serviceProviderGatewayActionKeys["default"].GET_ASSOCIATE_CONTACT_PREFERENCES,
    payload: {
      promise: _serviceProviderGatewayService["default"].getAssociateContactPreferences(userId)
    }
  };
}
function saveAssociateContactPreferences(params) {
  return {
    type: _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES,
    payload: {
      data: {
        params: params
      },
      promise: _serviceProviderGatewayService["default"].saveAssociateContactPreferences(params)
    }
  };
}
function getAssociateContactPreferencesByEmail(email, apiToken, serviceProviderId) {
  return {
    type: _serviceProviderGatewayActionKeys["default"].GET_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL,
    payload: {
      promise: _serviceProviderGatewayService["default"].getAssociateContactPreferencesByEmail(email, apiToken, serviceProviderId)
    }
  };
}
function saveAssociateContactPreferencesByEmail(_ref) {
  var email = _ref.email,
    apiToken = _ref.apiToken,
    preferences = _ref.preferences,
    serviceProviderId = _ref.serviceProviderId;
  return {
    type: _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL,
    payload: {
      data: {
        params: {
          email: email,
          apiToken: apiToken,
          preferences: preferences,
          serviceProviderId: serviceProviderId
        }
      },
      promise: _serviceProviderGatewayService["default"].saveAssociateContactPreferencesByEmail({
        email: email,
        apiToken: apiToken,
        preferences: preferences,
        serviceProviderId: serviceProviderId
      })
    }
  };
}

// Unsubscribe action uses the same API as saving associate contact preferences.
// It is a separate action to allow UI to render different alert messages on unsubscribing on page load vs. saving from a form submit.
function unsubscribeFromAssociateContactPreferenceByEmail(_ref2) {
  var email = _ref2.email,
    apiToken = _ref2.apiToken,
    preferences = _ref2.preferences,
    serviceProviderId = _ref2.serviceProviderId;
  return {
    type: _serviceProviderGatewayActionKeys["default"].UNSUBSCRIBE_FROM_ASSOCIATE_CONTACT_PREFERENCE_BY_EMAIL,
    payload: {
      data: {
        params: {
          email: email,
          apiToken: apiToken,
          preferences: preferences,
          serviceProviderId: serviceProviderId
        }
      },
      promise: _serviceProviderGatewayService["default"].saveAssociateContactPreferencesByEmail({
        email: email,
        apiToken: apiToken,
        preferences: preferences,
        serviceProviderId: serviceProviderId
      })
    }
  };
}
function resetSaveAssociateContactPreferencesByEmail() {
  return {
    type: _serviceProviderGatewayActionKeys["default"].SAVE_ASSOCIATE_CONTACT_PREFERENCES_BY_EMAIL_RESET
  };
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/account-ion/lib/modules/common/actions/serviceProviderGatewayActions.js
// module id = 979
// module chunks = 9